import { z } from "zod";

export const NormalizedInvoiceSchema = z.object({
  invoice_number: z.string().min(1),
  issue_date: z.string().date(),
  net_amount: z.string().regex(/^\d+\.\d{2}$/),
  gross_amount: z.string().regex(/^\d+\.\d{2}$/),
  vat_rate: z.enum(["23", "8", "5", "0", "zw", "oo"]).nullable(),
  payment_due_date: z.string().date().nullable(),
  counterparty_nip: z.string().regex(/^(?:\d{10}|\d{11})$/).nullable(),
  counterparty_name: z.string().nullable(),
  counterparty_email: z.string().email().nullable(),
  source: z.enum(["ksef", "csv"]),
  invoice_type: z.enum(["cost", "sales"]),
  ksef_reference_id: z.string().nullable(),
  incomplete_fields: z.array(z.string()),
  // Feature 018: normalized bank account from source document (NULL when unavailable)
  bank_account: z.string().nullable().optional(),
});
export type NormalizedInvoice = z.infer<typeof NormalizedInvoiceSchema>;

export const ImportResultSchema = z.object({
  invoices: z.array(NormalizedInvoiceSchema),
  total: z.number().int().min(0),
  source: z.enum(["ksef", "csv"]),
  invoice_type: z.enum(["cost", "sales"]).nullable(),
  date_range: z.object({ from: z.string().date(), to: z.string().date() }).nullable(),
  parse_errors: z.number().int().min(0),
  warnings: z.array(z.string()),
});
export type ImportResult = z.infer<typeof ImportResultSchema>;

export const KsefImportRequestSchema = z
  .object({
    from: z.string().date(),
    to: z.string().date(),
    invoice_type: z.enum(["cost", "sales"]).optional(),
    limit: z.number().int().min(1).max(10_000).optional(),
  })
  .refine((d) => d.from <= d.to, { message: "`to` must be >= `from`" });
export type KsefImportRequest = z.infer<typeof KsefImportRequestSchema>;
